import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventNews extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventNews';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            title: null,
            html_desc: '',
            html_desc__tc: '',
            html_desc__sc: '',
            html_desc__id: '',
            html_desc__vn: '',
            html_desc__fr: '',
            scheduledAt: null,
        }
    }
}

const servicePath = 'f-news';
const servicePlugin = makeServicePlugin({
    Model: EventNews,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin